let musicVolume = 1;
let sfxVolume = 1;
let projectileThreshold = 3;

class Settings {

  /* GENERAL CONFIG SETTINGS */
  static get DEBUG() { return false; }
  static get GRAVITY_NORMAL() { return 1800; }
  static get GRAVITY_HIGH() { return 3000; }
  static get PLAYERX() { return 200; }
  static get PLAYERY() { return 220; }
  static get SPEED() { return 400; }
  static get MAX_SPEED() { return 650; }
  static get SPEEDUP_PER_SECOND() { return 0.008; }
  static get JUMPHEIGHT() { return 800; }
  static get LEVEL_THRESHOLD() { return 15; }
  static get FADE_SPEED() { return 4000; }
  static get PROJECTILE_HIGH() { return 140; }
  static get PROJECTILE_LOW() { return 330; }
  static get HEALTH_DEPLETION_RATE() { return 0.10; }
  static get PICKUP_AMOUNT() { return 12; }
  static get HURT_AMOUNT() { return 15; }

  static get PROJECTILE_THRESHOLD() { return projectileThreshold; } // platforms recycled before throwing
  static set PROJECTILE_THRESHOLD(value) { projectileThreshold = value; };
  /* AUDIO GETTERS/SETTERS */
  static get MUSIC_VOLUME() { return musicVolume; };
  static set MUSIC_VOLUME(value) { musicVolume = value; };
  static get SFX_VOLUME() { return sfxVolume; };
  static set SFX_VOLUME(value) { sfxVolume = value; };

  /* SETTING SAVE AND LOAD */
  static loadSetting(setting) {
    if(window.localStorage.getItem(setting) == null)
        return "true"; // default settings to 'on'

    return window.localStorage.getItem(setting);
  }

  static saveSetting(setting, value) {
    window.localStorage.setItem(setting, value);
  }
}

export default Settings;
